<template>
<div class="article-details-bullets">
    <div class="container-bullets">
        <div class="title"><span>{{ widgetConfig.SubheadText}}</span></div>
        <div class="body-text">
            <p v-html="widgetConfig.BodyText"></p>
        </div>
    </div>
    <div class="divider-line"></div>
</div>
</template>

<script>
export default {
    name: "ArticleDetailsBullets",
    props: {
        widgetConfig: Object
    }
}
</script>

<style lang="scss" scoped>
.article-details-bullets {
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    padding: 0px 15px;
    .divider-line {
        border-bottom: 1px solid #B3B4B5;
    }

    .container-bullets {
        padding: 24px 0px;
        display: flex;
        flex-direction: row;

        .title {
            width: 314px;
            font-family: $font-family-primary;
            font-style: normal;
            font-weight: normal;
            font-size: 20px;
            line-height: 32px;
            color: $red-primary;
            margin-right: 24px;
        }

        .body-text {
            width: 652px;

             p {
                    padding: 0px;
                }
        }
    }
}

@include wide-mobile {
    .article-details-bullets {
        padding: 0px;
        .container-bullets {
            flex-direction: column;
            margin: 0px 24px;

            .body-text {
                width: 100%;

                p {
                    padding: 0px;
                }
            }

            .title {

                width: 100%;
                margin-bottom: 16px;

            }

        }

        .divider-line {
            
            margin: 0px 24px;
            border-bottom: 1px solid #B3B4B5;
        }
    }
}
</style>
